export default __webpack_public_path__ + "static/media/pos-pro-10.6044a982.jpg";